import { jsx as i, jsxs as b, Fragment as p } from "react/jsx-runtime";
import { c as w } from "./clsx-OuTLNxxd.js";
import { forwardRef as v } from "react";
import "./components/elements/button/iconButton/iconButton.js";
import { I as m } from "./icon-B72I4fRl.js";
import "./components/elements/icon/iconsList.js";
import { Loader as N } from "./components/elements/loader/loader.js";
const O = "_button_z1os6_29", T = "_disabled_z1os6_43", B = "_loader_z1os6_263", s = {
  button: O,
  disabled: T,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: B,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, I = v(
  ({
    text: o,
    color: g = "primary",
    size: u = "medium",
    isFullWidth: h = !1,
    icon: t,
    iconPosition: r = "left",
    isLoading: a = !1,
    iconSize: _ = "medium",
    isContrasted: f = !1,
    disabled: l = !1,
    className: z,
    children: y,
    ...e
  }, n) => {
    const d = w(
      s.button,
      s[k[g]],
      s[x[u]],
      h && s["is-full-width"],
      l && s.disabled,
      r === "right" && s["has-icon-right"],
      f && s["is-contrasted"],
      a && s["is-loading"],
      z
    ), c = /* @__PURE__ */ b(p, { children: [
      a && /* @__PURE__ */ i(N, { className: s.loader, onDark: !0, size: "small" }),
      t && r === "left" && /* @__PURE__ */ i(m, { color: "inherit", size: _, name: t }),
      y ?? o,
      t && r === "right" && /* @__PURE__ */ i(m, { color: "inherit", size: _, name: t })
    ] });
    if (S(e))
      return /* @__PURE__ */ i(
        "a",
        {
          ...e,
          href: l ? void 0 : e.href,
          className: d,
          target: e.target,
          ref: n,
          children: c
        }
      );
    if (C(e))
      return /* @__PURE__ */ i(
        "button",
        {
          disabled: a || l,
          ...e,
          className: d,
          ref: n,
          children: c
        }
      );
  }
);
I.displayName = "Button";
const k = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, x = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
}, Z = {
  left: "left",
  right: "right"
};
function S(o) {
  return "href" in o && typeof o.href == "string";
}
function C(o) {
  return !("href" in o);
}
export {
  I as B,
  k as a,
  x as b,
  Z as c,
  C as d,
  S as i
};
